export { default } from 'ember-cli-head/services/head-data';
